import { create } from 'zustand';

type Theme = 'dark' | 'light';

const KEY = 'cc-theme';

const read = (): Theme => {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
};

const apply = (t: Theme) => {
  const el = document.documentElement;
  el.setAttribute('data-theme', t);
  el.classList.toggle('dark', t === 'dark');
  el.classList.toggle('light', t === 'light');
};

interface ThemeState {
  theme: Theme;
  toggleTheme: () => void;
  initTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: read(),

  toggleTheme: () => {
    const next: Theme = get().theme === 'dark' ? 'light' : 'dark';
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* ignore */
    }
    apply(next);
    set({ theme: next });
  },

  initTheme: () => {
    const t = read();
    apply(t);
    set({ theme: t });
  },
}));
